import Typography from "@mui/material/Typography";
import { AdminRoleLabels } from "entities/auth/constants";
import { AdminRole } from "entities/auth/types";
import { type FC } from "react";
import { StyledChip } from "./styled";

type ChipProps = {
  title: AdminRole;
};

const RoleChip: FC<ChipProps> = ({ title }) => {
  const color = AdminRoleLabels[title].color;

  return (
    <StyledChip borderColor={color} bgColor="transparent">
      <Typography variant="bodySMedium" color={color}>
        {AdminRoleLabels[title].label}
      </Typography>
    </StyledChip>
  );
};

export default RoleChip;
